exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ChannelAnalytics_userChannelStatistics__K5KED {\n  width: 100%;\n  padding: 4px;\n  margin-top: 8px; }\n  .ChannelAnalytics_userChannelStatistics__K5KED .ChannelAnalytics_tableContainer__1oSnB {\n    margin-top: 8px; }\n    .ChannelAnalytics_userChannelStatistics__K5KED .ChannelAnalytics_tableContainer__1oSnB .ChannelAnalytics_displayName__2_KG3 {\n      display: -webkit-flex;\n      display: flex;\n      -webkit-align-items: center;\n              align-items: center; }\n      .ChannelAnalytics_userChannelStatistics__K5KED .ChannelAnalytics_tableContainer__1oSnB .ChannelAnalytics_displayName__2_KG3 .ChannelAnalytics_avatar__1MGcH {\n        margin-right: 10px; }\n", ""]);

// exports
exports.locals = {
	"userChannelStatistics": "ChannelAnalytics_userChannelStatistics__K5KED",
	"tableContainer": "ChannelAnalytics_tableContainer__1oSnB",
	"displayName": "ChannelAnalytics_displayName__2_KG3",
	"avatar": "ChannelAnalytics_avatar__1MGcH"
};